<script setup lang='ts'>
import type { Schemas } from '#shopware';
import { pascalCase } from 'scule';

useRouteCache((helper) => {
    helper.setMaxAge(60).setCacheable()
})

const route = useRoute();
const { locale } = useI18n();
const routePath = route.path.replace(new RegExp('\\b'+`${locale.value}`+'\\b'), '').replace('//', '/');

// Build query string for redirect preservation
let query = ''
if (route?.query != null && Object.keys(route?.query).length > 0) {
    query = new URLSearchParams(route.query as Record<string, string>).toString()
}

const { resolvePath } = useNavigationSearch()
const { data: seoResult, error } = await useAsyncData(
    `cmsResponse${routePath}`,
    async () => {
        return resolvePath(routePath)
    },
)

if (seoResult?.value?.redirect?.statusCode != null) {
    const { url, statusCode, external } = seoResult.value.redirect
    await navigateTo(
        `${url}${query !== '' ? '?' + query : ''}`,
        { redirectCode: statusCode, external: external === true }
    )
}

if (!seoResult?.value?.seoUrl) {
    throw createError({
        statusCode: 404,
        message: 'not found',
        fatal: true
    })
}

if (error.value) {
    showError(error.value as Error)
}

const { routeName, foreignKey } = useNavigationContext(
    seoResult.value.seoUrl as unknown as Ref<Schemas['SeoUrl']>,
)

const pageComponent = computed(() => {
    return resolveComponent(pascalCase(routeName.value as string));
});
</script>

<template>
    <component :is='pageComponent' v-if='pageComponent' :navigation-id='foreignKey' />
</template>
